// src/components/Footer.js
import React from "react";
import { AppBar, Toolbar, Button } from "@mui/material";
import { NavLink } from "react-router-dom";

const Footer = () => {
  // Navigation items
  const navItems = [
    { label: "Dashboard", path: "/dashboard" },
    { label: "Payouts", path: "/payouts" },
    { label: "Shops", path: "/shops" },
    { label: "Affiliates", path: "/affiliates" },
    { label: "Logs", path: "/logs" },
  ];

  return (
    <AppBar position="static" color="primary" sx={{ top: "auto", bottom: 0 }}>
      <Toolbar sx={{ justifyContent: "center" }}>
        {navItems.map((item) => (
          <Button
            key={item.label}
            color="inherit"
            component={NavLink}
            to={item.path}
            sx={{
              textDecoration: "none",
              "&.active": {
                fontWeight: "bold",
              },
              mx: 1, // adds horizontal margin between buttons
            }}
          >
            {item.label}
          </Button>
        ))}
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
